import { Link } from "react-router-dom";

type LogoProps = {
  width?: number;
  height?: number;
  to?: string;
};

const Logo: React.FC<LogoProps> = ({ height = 47, to = "/" }) => {
  const logoHeight = `${height}px`;

  const LogoImage = (
    <img
      src="/fujairah-ports-authority.svg"
      alt="Fujairah Ports Authority"
      className="w-auto"
      style={{ height: logoHeight }}
      data-testid="logo"
    />
  );

  return (
    <Link to={to} className="flex items-center gap-2 text-blue-800 font-semibold text-lg">
      {LogoImage}
    </Link>
  );
};

export default Logo;
